"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextGenResponseHandler = void 0;
const ResponseHandler_1 = require("./ResponseHandler");
class TextGenResponseHandler extends ResponseHandler_1.ResponseHandler {
    async handleFuncDataSource(query, res) {
        return new ResponseHandler_1.TransformResponse(res.value, res.isEnded);
    }
}
exports.TextGenResponseHandler = TextGenResponseHandler;
